/* eslint-disable no-prototype-builtins */
const SITES_BY_ID = {
  1: {
    site: "AmericanBlinds.com",
    siteLogoSrc: "/images/siteLogos/ABLogo_product-header.svg",
  },
  2: {
    site: "Blinds.ca",
    siteLogoSrc: "/images/siteLogos/BCOM-BCALogo_product-header.svg",
  },
  3: {
    site: "Blinds.com",
    siteLogoSrc: "/images/siteLogos/BCOM-BCALogo_product-header.svg",
  },
  5: {
    site: "JustBlinds.com",
    siteLogoSrc: "/images/siteLogos/THDLogo_product-header.svg",
  },
  11: {
    site: "TheHomeDepot",
    siteLogoSrc: "/images/siteLogos/THDLogo_product-header.svg",
  },
};

export const getSiteSpecificLogo = (siteId) => {
  const siteIdIsValid = SITES_BY_ID.hasOwnProperty(siteId);
  // default to homedepot logo if siteId is invalid
  let siteLogo = SITES_BY_ID[11];
  if (siteIdIsValid) {
    siteLogo = SITES_BY_ID[siteId];
  }

  return siteLogo;
};
